// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".two_column_images[data-v-cf3e856e]{background:#fff}", "",{"version":3,"sources":["webpack://./resources/js/modules/two_column_images.vue"],"names":[],"mappings":"AAGI,oCACI,eAFR","sourcesContent":["\n    @import '@variables'\n\n    .two_column_images\n        background: $white\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
